export const t = (msg: string, _options?: { [key: string]: unknown }): string => {
  return msg;
};
